import React from 'react'
import { useSelector } from 'react-redux'
import { Dropdown } from 'primereact/dropdown'
import { selectAllAssets } from 'providers/AssetLoader/store/selectors'

/**
 * Contribution Type filter template for Works grids
 * Shows all contribution types from assets
 * @param {object} options - Filter options from PrimeReact column
 */
const WorkContributionTypeFilterTemplate = ({ options }) => {
    const assets = useSelector(selectAllAssets)
    const contributionTypes = assets?.contributionTypes || []
    
    const dropdownOptions = [
        { label: 'Empty', value: '__EMPTY__' },
        ...contributionTypes.map(ct => ({
            label: ct.name,
            value: ct.name
        }))
    ]

    return (
        <Dropdown
            value={options.value}
            options={dropdownOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(e) => options.filterCallback(e.value, options.index)}
            placeholder="Select Contribution Type"
            className="p-column-filter"
            showClear
        />
    )
}

export default WorkContributionTypeFilterTemplate
